import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { isDefined } from '@evorait/pace-core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { getFormFunctionalElementByIdFactory } from '../../store/selectors/form.selector';
import { FormsState } from '../../store/state/pace-forms.state';
import { ContentId } from '../../types/content-block';
import { isDatePerformed } from '../../types/date-performed';
import { isDefectiveComponentReplacement } from '../../types/defective-component-replacement';
import { isDiscrepancyLog } from '../../types/discrepancy-log';
import { FunctionalElement } from '../../types/functional-element';
import { isMaterialSerialNumber } from '../../types/material-serial-number';
import { isAstoriaOption, isCosimaOption } from '../../types/option';
import { isReplacementDateOrLastProcedureDate } from '../../types/replacement-or-last-procedure-date';
import { isSignature } from '../../types/signature';
import { isRemarksFunctionalElement, isStandardFunctionalElement } from '../../types/standard-functional-element';
import { isValue } from '../../types/value-functional-element';
import { isDropDownOptionsElement } from '../../types/drop-down-options';

@Component({
    selector: 'pace-functional-element',
    templateUrl: './functional-element.component.html',
    styleUrls: ['./functional-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunctionalElementComponent implements OnInit {
    @Input()
    public id: ContentId;

    @Input()
    public parentForm: FormArray | undefined;

    public functionalElement$: Observable<FunctionalElement>;

    public isStandardFunctionalElement$: Observable<boolean>;
    public isDiscrepancyLog$: Observable<boolean>;
    public isMaterialSerialNumber$: Observable<boolean>;
    public isDatePerformed$: Observable<boolean>;
    public isReplacementOrLastProcedureDate$: Observable<boolean>;
    public isSignature$: Observable<boolean>;
    public isValue$: Observable<boolean>;
    public isAstoriaOption$: Observable<boolean>;
    public isCosimaOption$: Observable<boolean>;
    public isDefectiveComponentReplacement$: Observable<boolean>;
    public isDropDownOptionsFunctionalElement$: Observable<boolean>;
    public constructor(private readonly store: Store<FormsState>) {}

    public ngOnInit(): void {
        this.functionalElement$ = this.store
            .select(getFormFunctionalElementByIdFactory({ id: this.id }))
            .pipe(filter(isDefined));

        this.isStandardFunctionalElement$ = this.functionalElement$.pipe(
            map((f) => isStandardFunctionalElement(f) || isRemarksFunctionalElement(f)),
        );
        this.isDiscrepancyLog$ = this.functionalElement$.pipe(map(isDiscrepancyLog));
        this.isMaterialSerialNumber$ = this.functionalElement$.pipe(map(isMaterialSerialNumber));
        this.isDatePerformed$ = this.functionalElement$.pipe(map(isDatePerformed));
        this.isReplacementOrLastProcedureDate$ = this.functionalElement$.pipe(
            map(isReplacementDateOrLastProcedureDate),
        );
        this.isSignature$ = this.functionalElement$.pipe(map(isSignature));
        this.isValue$ = this.functionalElement$.pipe(map(isValue));
        this.isAstoriaOption$ = this.functionalElement$.pipe(map(isAstoriaOption));
        this.isCosimaOption$ = this.functionalElement$.pipe(map(isCosimaOption));
        this.isDefectiveComponentReplacement$ = this.functionalElement$.pipe(map(isDefectiveComponentReplacement));
        this.isDropDownOptionsFunctionalElement$ = this.functionalElement$.pipe(map(isDropDownOptionsElement));
    }
}
